module.exports = __webpack_public_path__ + "assets/img/logitech-landingpage-and-website-internal-w960.bb5ee55f.webp";